import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

type TokenState = {
  accessToken: string | null;
  refreshToken: string | null;
  accessTokenExpiresAt: string | null;
  refreshTokenExpiresAt: string | null;
  isRefreshingToken?: boolean | null;
};

export type AuthState = TokenState & {
  isRefreshTokenExpired: () => boolean;
  setIsRefreshingToken: (isRefreshingToken: boolean) => void;
  setTokenState: (tokenState: TokenState) => void;
  isAccessTokenExpired: () => boolean;
  signOut: () => void;
};

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set, get) => ({
        accessToken: null,
        refreshToken: null,
        accessTokenExpiresAt: null,
        refreshTokenExpiresAt: null,
        isRefreshingToken: null,
        isRefreshTokenExpired: () => {
          const refreshTokenExpiresAt = get().refreshTokenExpiresAt;
          if (!refreshTokenExpiresAt) return true;
          const expiresAt = new Date(refreshTokenExpiresAt);
          const now = new Date();
          return now > expiresAt;
        },
        setIsRefreshingToken: (isRefreshingToken: boolean) => {
          set({
            isRefreshingToken,
          });
        },
        isAccessTokenExpired: () => {
          const accessTokenExpiresAt = get().accessTokenExpiresAt;
          if (!accessTokenExpiresAt) return true;
          const expiresAt = new Date(accessTokenExpiresAt);
          const now = new Date();
          return now > expiresAt;
        },
        setTokenState: (tokenState) => set(tokenState),
        signOut: () => {
          set({
            accessToken: null,
            refreshToken: null,
            accessTokenExpiresAt: null,
            refreshTokenExpiresAt: null,
            isRefreshingToken: null,
          });
        },
      }),
      {
        name: "auth-storage",
      },
    ),
  ),
);
